import React from 'react';
import ViewBookings from './ViewBookings';

const MultipleBookingView = () => {
  return (
    <div className="space-y-6">
      <ViewBookings />
    </div>
  );
};

export default MultipleBookingView;


